// App.tsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SavedUnitsProvider } from './context/SavedUnitsContext';
import { ToastProvider } from './components/ui';
import { ProtectedRoute } from './components/layout';

// Public pages
import { BuildingPage } from './pages/public/BuildingPage';
import { UnitDetailPage } from './pages/public/UnitDetailPage';
import { ComparePage } from './pages/public/ComparePage';
import { ReferralPage } from './pages/public/ReferralPage';
import { DemoLandingPage } from './pages/DemoLandingPage';

// Auth pages
import { Login } from './pages/auth/Login';

// Admin pages
import {
  Dashboard,
  BuildingManage,
  ViewingRequestsPage,
  AnalyticsPage,
  QRCodePage,
  UsersPage,
  SettingsPage,
  ApplicationsPage,
  TemplatesPage,
  TemplateDetail,
  UnitTypesPage
} from './pages/admin';

// Error pages
import { NotFound } from './pages/NotFound';

// Dev pages
import DesignSystem from './pages/DesignSystem';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SavedUnitsProvider>
          <ToastProvider>
          <Routes>
            {/* Public Routes - QR Code Landing Pages */}
            <Route path="/b/:slug" element={<BuildingPage />} />
            <Route path="/b/:slug/unit/:unitId" element={<UnitDetailPage />} />
            <Route path="/compare" element={<ComparePage />} />

            {/* Referral Route */}
            <Route path="/refer" element={<ReferralPage />} />

          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />

          {/* Admin Routes - Protected */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/buildings/:slug"
            element={
              <ProtectedRoute>
                <BuildingManage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/buildings/:slug/viewings"
            element={
              <ProtectedRoute>
                <ViewingRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/buildings/:slug/analytics"
            element={
              <ProtectedRoute>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/buildings/:slug/qr"
            element={
              <ProtectedRoute>
                <QRCodePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/buildings/:slug/templates"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <TemplatesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/buildings/:slug/templates/:templateId"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <TemplateDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/applications"
            element={
              <ProtectedRoute>
                <ApplicationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/unit-types"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <UnitTypesPage />
              </ProtectedRoute>
            }
          />

          {/* Redirect legacy routes */}
          <Route
            path="/admin/buildings"
            element={
              <ProtectedRoute>
                <Navigate to="/admin" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/analytics"
            element={
              <ProtectedRoute>
                <Navigate to="/admin" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />

          {/* Design System Reference */}
          <Route path="/design" element={<DesignSystem />} />

          {/* Root - Demo Landing Page */}
          <Route path="/" element={<DemoLandingPage />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </ToastProvider>
        </SavedUnitsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
